/*
 * PEWNA "For All Sizes" — reveal hotspots when section scrolls into view.
 * Adds .is-revealed class; CSS handles the fade-in + stagger.
 * No-op if IntersectionObserver is unavailable (graceful: cards just show).
 */
(function () {
  const sections = document.querySelectorAll('.pewna-for-all-sizes[data-reveal]');
  if (!sections.length) return;

  if (!('IntersectionObserver' in window)) {
    sections.forEach((s) => s.classList.add('is-revealed'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.2, rootMargin: '0px 0px -10% 0px' }
  );

  sections.forEach((s) => observer.observe(s));
})();
